import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import MetaLayoutVertical from 'Components/UI/Meta/MetaForm/Components/MetaLayout/MetaLayoutVertical';
import {
  FDBodyText, FDDialogActions, FDDialogContent, FDPrimaryActionButton, FDStack,
} from '@facet-wealth/design';
import { dataAttrs } from 'Helpers/Testing';


function ChallengeTOTPLayout() {
  const { resource, onSubmit, saving } = useMetaLayoutContext();

  return (
    <>
      <MetaControlField attr={'title'} />
      <FDDialogContent>
        <FDStack direction={'column'} justifyContent={'center'} alignItems={'stretch'} spacing={2} {...dataAttrs('dicrs-challenge-totp-layout')}>
          <MetaControlField attr={'primaryText'} />
          <FDBodyText value={'Please enter the code generated by the Google Authenticator app on your device.'} />
          <MetaLayoutVertical resource={resource} />
        </FDStack>
      </FDDialogContent>
      <FDDialogActions>
        <FDPrimaryActionButton
          label={'Submit'}
          onClick={onSubmit}
          loading={saving}
          test={'dicrs-challenge-totp-layout-submit-button'}
        />
      </FDDialogActions>
    </>
  );
}

ChallengeTOTPLayout.propTypes = {
};

ChallengeTOTPLayout.defaultProps = {
};

export default ChallengeTOTPLayout;
